import isType from './is-type';
var isRegExp = function (str) {
    return isType(str, 'RegExp');
};
export default isRegExp;
//# sourceMappingURL=is-reg-exp.js.map